import { z } from "zod";

export default () => z.object({
    address: z.string().min(1),
    ownerName: z.string().min(1),
});